<template>
  <div :class="style.buttonSave" name="Save">
    <button :class="style.notActive" v-if="status == 'NO'">Сохранить</button>
    <button :class="style.default" v-if="status == ''">Сохранить</button>
    <button
      :class="style.loading"
      v-if="status == 'Подожди'"
      v-text="'Ждите'"
    />
    <button :class="style.good" v-if="status == 'Готово'" v-text="status" />
    <button :class="style.bad" v-if="status == 'Ошибка'" v-text="status" />
  </div>
</template>
<script lang="ts">
import {defineComponent} from "vue";
import style from "./ButtonSave.module.scss";
export default defineComponent({
  props: {
    status: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      style
    };
  }
});
</script>
